const API_BASE_URL = "https://base.byvalindia.com:10000";
// const API_BASE_URL = "https://10.0.0.10:4405";

export default API_BASE_URL;